import * as React from "react"

import SubHeader from "components/Shared/SubHeader"
import PhronesisCalendar from "components/Shared/PhronesisCalendar"

import * as paths from "constants/paths"
import { filtersToShow } from "components/CustomerBehavior/Switching/utils"
import { GlobalFilterSwitching } from "../GlobalFilterSwitching"
import { Interval } from "components/Shared/PhronesisCalendar/PhronesisCalendar.domain"

type SubHeaderSwitchingProps = {
	onChangeCalendar: (interval: Interval) => void
}

const SubHeaderSwitching: React.FC<SubHeaderSwitchingProps> = (props) => {
	const { onChangeCalendar } = props

	return (
		<SubHeader
			globalFiltersPanelId={"global-filters-switching"}
			parentPath={paths.CUSTOMER_BEHAVIOR}
			title={"phronesis.menu.option.customerbehavior.title"}
			filtersToShow={filtersToShow}
			subTitle={"phronesis.customerbehavior.application.switching"}
			titleContent={
				<div className="phronesis-calendar">
					<PhronesisCalendar setDateInterval={onChangeCalendar} />
				</div>
			}
			content={<GlobalFilterSwitching />}
		/>
	)
}

export default SubHeaderSwitching
